import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { capitalizeFirstLetter } from 'src/utils/string';
import { APRESENTACAO } from 'src/utils/constants';
import { MODULOS } from 'src/utils/constants';

export const tipos = {
  Valores: { id: 'Valores', label: 'valores', resource: 'valores' },
  Relacionamento: { id: 'Relacionamento', label: 'label.relacionamento' },
  GraficoComparativo: { id: 'GraficoComparativo', label: 'graficoComparativo' },
  GraficoDesvio: { id: 'GraficoDesvio', label: 'label.graficoDeDesvios' },
  PlanoAcao: {
    id: 'PlanoAcao',
    label: 'label.planoAcao',
    resource: 'planodeacao',
  },
  PlanoAcaoGantt: {
    id: 'PlanoAcaoGantt',
    label: 'label.planoAcaoGantt',
    resource: 'planodeacao',
  },
  MapaEstrategico: { id: 'MapaEstrategico', label: 'label.mapaEstrategico' },
  Dashboard: { id: 'Dashboard', label: 'dashboard', resource: 'dashboard' },
  Painel: { id: 'Painel', label: 'painel' },
  ResultadoArea: {
    id: 'ResultadoArea',
    label: 'resultadoArea',
    resource: 'area',
  },
  MatrizResultado: {
    id: 'MatrizResultado',
    label: 'matrizderesultados',
    resource: 'matrizderesultados',
  },
  RelatorioAcompanhamento: {
    id: 'RelatorioAcompanhamento',
    label: 'label.relatorioAcompanhamento',
    resource: 'relatoriodeacompanhamento',
  },
  GraficoIndicadores: { id: 'GraficoIndicadores', label: 'graficoIndicadores' },
  GraficoAcompanhamento: {
    id: 'GraficoAcompanhamento',
    label: 'graficoAcompanhamento',
  },
  DesvioCentroCusto: {
    id: 'DesvioCentroCusto',
    label: 'desviosPorCentroDeCusto',
    resource: 'centrocusto',
  },
  Imagem: { id: 'Imagem', label: 'label.imagem' },
  DesvioPacoteConta: { id: 'DesvioPacoteConta', label: 'label.desvioPacote' },
  ValoresPacoteConta: { id: 'ValoresPacoteConta', label: 'valoresPacote' },
  Organograma: { id: 'Organograma', label: 'organograma' },
  [APRESENTACAO.CALENDARIO]: { id: 'Calendario', label: 'Calendario' },
  [APRESENTACAO.RISCO]: {
    id: APRESENTACAO.RISCO,
    label: 'risco',
    resource: 'risco',
  },
  [APRESENTACAO.PONTOCONTROLE]: {
    id: APRESENTACAO.PONTOCONTROLE,
    label: 'pontoControle',
    resource: 'pontodecontrole',
  },
  [APRESENTACAO.REVISOESPONTOCONTROLE]: {
    id: APRESENTACAO.REVISOESPONTOCONTROLE,
    label: 'revisoesPontoControle',
    resource: 'revisoesdecontrole',
  },
  [APRESENTACAO.MATRIZRISCO]: {
    id: APRESENTACAO.MATRIZRISCO,
    label: 'matrizRisco',
    resource: 'risco',
  },
  CardMetas: { id: 'CardMetas', label: 'cardMetas', resource: 'cardmetas' },
  OKR: { id: 'OKR', label: 'OKR' },
  StatusReport: {
    id: 'StatusReport',
    label: 'statusreport',
    resource: 'statusreport',
  },
  [APRESENTACAO.RESULTADOITEM]: {
    id: APRESENTACAO.RESULTADOITEM,
    label: 'resultadoItem',
    resource: 'resultadoItem',
  },
};

export const objetos = {
  Valores: {
    format: (n) => {
      return n.objeto.nome;
    },
  },
  Relacionamento: {
    format: (n) => {
      return n.objeto.nome;
    },
  },
  GraficoComparativo: {
    format: (n) => {
      return n.objeto.descricao;
    },
  },
  GraficoDesvio: {
    format: (n) => {
      return n.objeto.nome;
    },
  },
  PlanoAcao: {
    format: (n) => {
      let descricao = '';

      if (n.objeto && n.objeto != null) {
        descricao = n.objeto.nome;
      }

      if (n.colaborador && n.colaborador != null) {
        descricao =
          descricao == ''
            ? n.colaborador.nome
            : descricao + ' - ' + n.colaborador.nome;
      }

      if (n.area && n.area != null) {
        descricao =
          descricao == '' ? n.area.nome : descricao + ' - ' + n.area.nome;
      }

      if (n.status && n.status != null) {
        descricao =
          descricao == ''
            ? n.status.descricao
            : descricao + ' - ' + n.status.descricao;
      }

      if (n.tipoOrigem) {
        descricao =
          descricao == ''
            ? n.tipoOrigem.descricao
            : descricao + ' - ' + n.tipoOrigem.descricao;
      }

      return descricao;
    },
  },
  PlanoAcaoGantt: {
    format: (n) => {
      let descricao = '';

      if (n.objeto && n.objeto != null) {
        descricao = n.objeto.nome;
      }

      if (n.colaborador && n.colaborador != null) {
        descricao =
          descricao == ''
            ? n.colaborador.nome
            : descricao + ' - ' + n.colaborador.nome;
      }
      return descricao;
    },
  },
  MapaEstrategico: {
    format: (n) => {
      return n.objeto.descricao;
    },
  },
  Dashboard: {
    format: (n) => {
      return n.objeto.descricao;
    },
  },
  Painel: {
    format: (n) => {
      return n.objeto.descricao;
    },
  },
  ResultadoArea: {
    format: (n) => {
      return n.objeto.nome;
    },
  },
  MatrizResultado: {
    format: (n) => {
      let descricao = '';

      if (n.area && n.area != null) {
        descricao = n.area.nome;
      }

      if (n.colaborador && n.colaborador != null) {
        descricao =
          descricao == ''
            ? n.colaborador.nome
            : descricao + ' - ' + n.colaborador.nome;
      }

      if (n.item && n.item != null) {
        descricao =
          descricao == '' ? n.item.nome : descricao + ' - ' + n.item.nome;
      }

      return descricao;
    },
  },
  RelatorioAcompanhamento: {
    format: (n) => {
      return n.objeto && n.objeto.nome;
    },
  },
  GraficoIndicadores: {
    format: (n) => {
      return (
        (n.centroCusto && n.centroCusto.nome) +
        ' - ' +
        (n.pacote && n.pacote.nome) +
        ' - ' +
        (n.indicadores && n.indicadores.nome)
      );
    },
  },
  GraficoAcompanhamento: {
    format: (n) => {
      return (
        (n.centroCusto && n.centroCusto.nome) +
        ' - ' +
        (n.pacote && n.pacote.nome)
      );
    },
  },
  DesvioCentroCusto: {
    format: (n) => {
      return (
        (n.centroCusto && n.centroCusto.nome) +
        ' - ' +
        (n.pacote != null ? n.pacote.nome : '  ')
      );
    },
  },
  Imagem: {
    format: (n) => {
      return n.arquivo && n.arquivo.nome;
    },
  },
  DesvioPacoteConta: {
    format: (n) => {
      return (
        (n.centroCusto && n.centroCusto.nome) +
        ' - ' +
        (n.pacote != null ? n.pacote.nome : '  ')
      );
    },
  },
  ValoresPacoteConta: {
    format: (n) => {
      return (
        (n.centroCusto && n.centroCusto.nome) +
        ' - ' +
        (n.pacote != null ? n.pacote.nome : '  ')
      );
    },
  },
  Organograma: {
    format: (n) => {
      return n.area && n.area.nome;
    },
  },
  [APRESENTACAO.RISCO]: {
    format: (n) => {
      return n.tipoTela.descricao;
    },
  },
  [APRESENTACAO.PONTOCONTROLE]: {
    format: (n) => {
      return n.tipoTela.descricao;
    },
  },
  [APRESENTACAO.REVISOESPONTOCONTROLE]: {
    format: (n) => {
      return n.tipoTela.descricao;
    },
  },
  [APRESENTACAO.MATRIZRISCO]: {
    format: (n) => {
      return n.tipoTela.descricao;
    },
  },
  [APRESENTACAO.MATRIZRISCOPROCESSO]: {
    format: (n) => {
      return n.tipoTela.descricao;
    },
  },
  [APRESENTACAO.MATRIZRISCOPROCESSO]: {
    format: (n) => {
      return n.tipoTela.descricao;
    },
  },
  [APRESENTACAO.CALENDARIO]: {
    format: (n) => n.tipoTela.descricao,
  },
  CardMetas: {
    format: (n) => {
      let descricao = '';

      if (n.colaborador && n.colaborador != null) {
        descricao = n.colaborador.nome;
      }

      if (n.area && n.area != null) {
        descricao =
          descricao == '' ? n.area.nome : descricao + ' - ' + n.area.nome;
      }

      return descricao;
    },
  },
  OKR: {
    format: (n) => {
      let descricao = '';

      if (n.colaborador && n.colaborador != null) {
        descricao = n.colaborador.nome;
      }

      if (n.area && n.area != null) {
        descricao =
          descricao == '' ? n.area.nome : descricao + ' - ' + n.area.nome;
      }

      return descricao;
    },
  },
  StatusReport: {
    format: (n) => {
      return n.objeto.nome;
    },
  },
  [APRESENTACAO.RESULTADOITEM]: {
    format: (n) => {
      return n.objeto.nome;
    },
  },
};

export function descricaoObjeto(tela) {
  if (!tela) {
    return;
  }

  let tipo = tela.tipo;
  let objeto = objetos[tipo];
  let texto = objeto.format(tela);

  return texto;
}
@autobind
class TipoTela extends React.Component {
  static defaultProps = {
    disabled: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      tipos: [
        {
          id: tipos.Valores.id,
          descricao: this.props.intl.formatMessage(
            { id: tipos.Valores.label },
            { valores: capitalizeFirstLetter(this.props.resources.valores) }
          ),
          modulos: [1, 3],
        },
        {
          id: tipos.Relacionamento.id,
          descricao: this.props.intl.formatMessage({
            id: tipos.Relacionamento.label,
          }),
          modulos: [1, 3, 5],
        },
        {
          id: tipos.GraficoComparativo.id,
          descricao: this.props.intl.formatMessage({
            id: tipos.GraficoComparativo.label,
          }),
          modulos: [1, 3],
        },
        {
          id: tipos.GraficoDesvio.id,
          descricao: this.props.intl.formatMessage({
            id: tipos.GraficoDesvio.label,
          }),
          modulos: [1, 3],
        },
        {
          id: tipos.PlanoAcao.id,
          descricao: this.props.intl.formatMessage(
            { id: tipos.PlanoAcao.label },
            {
              planodeacao: capitalizeFirstLetter(
                this.props.resources.planodeacao
              ),
            }
          ),
          modulos: [1, 3, 5],
        },
        {
          id: tipos.PlanoAcaoGantt.id,
          descricao: this.props.intl.formatMessage(
            { id: tipos.PlanoAcaoGantt.label },
            {
              planodeacao: capitalizeFirstLetter(
                this.props.resources.planodeacao
              ),
            }
          ),
          modulos: [1, 3, 5],
        },
        {
          id: tipos.MapaEstrategico.id,
          descricao: this.props.intl.formatMessage({
            id: tipos.MapaEstrategico.label,
          }),
          modulos: [1, 3],
        },
        {
          id: tipos.Dashboard.id,
          descricao: this.props.intl.formatMessage(
            { id: tipos.Dashboard.label },
            { dashboard: this.props.resources.dashboard }
          ),
          modulos: [1, 2, 3, 5],
        },
        {
          id: tipos.Painel.id,
          descricao: this.props.intl.formatMessage({ id: tipos.Painel.label }),
          modulos: [1, 3],
        },
        {
          id: tipos.ResultadoArea.id,
          descricao: this.props.intl.formatMessage(
            { id: tipos.ResultadoArea.label },
            { area: capitalizeFirstLetter(this.props.resources.area) }
          ),
          modulos: [1, 3],
        },
        {
          id: tipos.MatrizResultado.id,
          descricao: this.props.intl.formatMessage(
            {
              id: tipos.MatrizResultado.label,
            },
            {
              matrizderesultados: capitalizeFirstLetter(
                this.props.resources.matrizderesultados
              ),
            }
          ),
          modulos: [1, 3],
        },
        {
          id: tipos.RelatorioAcompanhamento.id,
          descricao: this.props.intl.formatMessage(
            { id: tipos.RelatorioAcompanhamento.label },
            {
              relatoriodeacompanhamento: capitalizeFirstLetter(
                this.props.resources.relatoriodeacompanhamento
              ),
            }
          ),
          modulos: [1, 3],
        },
        {
          id: tipos.GraficoIndicadores.id,
          descricao: this.props.intl.formatMessage({
            id: tipos.GraficoIndicadores.label,
          }),
          modulos: [2],
        },
        {
          id: tipos.GraficoAcompanhamento.id,
          descricao: this.props.intl.formatMessage({
            id: tipos.GraficoAcompanhamento.label,
          }),
          modulos: [2],
        },
        {
          id: tipos.DesvioCentroCusto.id,
          descricao: this.props.intl.formatMessage(
            { id: tipos.DesvioCentroCusto.label },
            { centrocusto: this.props.resources.centrocusto }
          ),
          modulos: [2],
        },
        {
          id: tipos.Imagem.id,
          descricao: this.props.intl.formatMessage({ id: tipos.Imagem.label }),
          modulos: [1, 2, 3, 5],
        },
        {
          id: tipos.DesvioPacoteConta.id,
          descricao: this.props.intl.formatMessage({
            id: tipos.DesvioPacoteConta.label,
          }),
          modulos: [2],
        },
        {
          id: tipos.ValoresPacoteConta.id,
          descricao: this.props.intl.formatMessage({
            id: tipos.ValoresPacoteConta.label,
          }),
          modulos: [2],
        },
        {
          id: tipos.Organograma.id,
          descricao: this.props.intl.formatMessage({
            id: tipos.Organograma.label,
          }),
          modulos: [1, 3, 5],
        },
        {
          id: tipos[APRESENTACAO.CALENDARIO].id,
          descricao: this.props.intl.formatMessage({
            id: tipos[APRESENTACAO.CALENDARIO].label,
          }),
          modulos: [1, 2, 3, 5],
        },
        {
          id: tipos[APRESENTACAO.RISCO].id,
          descricao: this.props.intl.formatMessage(
            { id: tipos[APRESENTACAO.RISCO].label },
            { risco: capitalizeFirstLetter(this.props.resources.risco) }
          ),
          modulos: [5, MODULOS.ESCRITORIO_PROJETOS],
        },
        {
          id: tipos[APRESENTACAO.PONTOCONTROLE].id,
          descricao: this.props.intl.formatMessage(
            { id: tipos[APRESENTACAO.PONTOCONTROLE].label },
            {
              pontodecontrole: capitalizeFirstLetter(
                this.props.resources.pontodecontrole
              ),
            }
          ),
          modulos: [5],
        },
        {
          id: tipos[APRESENTACAO.REVISOESPONTOCONTROLE].id,
          descricao: this.props.intl.formatMessage(
            { id: tipos[APRESENTACAO.REVISOESPONTOCONTROLE].label },
            {
              revisoesdecontrole: capitalizeFirstLetter(
                this.props.resources.revisoesdecontrole
              ),
            }
          ),
          modulos: [5],
        },
        {
          id: tipos[APRESENTACAO.MATRIZRISCO].id,
          descricao: this.props.intl.formatMessage(
            { id: tipos[APRESENTACAO.MATRIZRISCO].label },
            { risco: capitalizeFirstLetter(this.props.resources.risco) }
          ),
          modulos: [5, MODULOS.ESCRITORIO_PROJETOS],
        },
        {
          id: tipos.CardMetas.id,
          descricao: this.props.intl.formatMessage(
            { id: tipos.CardMetas.label },
            { cardmetas: capitalizeFirstLetter(this.props.resources.cardmetas) }
          ),
          modulos: [1, 3],
        },
        {
          id: tipos.OKR.id,
          descricao: this.props.intl.formatMessage({ id: tipos.OKR.label }),
          modulos: [1],
        },
        {
          id: tipos.StatusReport.id,
          descricao: this.props.intl.formatMessage(
            { id: tipos.StatusReport.label },
            {
              statusreport: capitalizeFirstLetter(
                this.props.resources.statusreport
              ),
            }
          ),
          modulos: [1, 7],
        },
        {
          id: tipos[APRESENTACAO.RESULTADOITEM].id,
          descricao: this.props.intl.formatMessage({
            id: tipos[APRESENTACAO.RESULTADOITEM].label,
          }),
          modulos: [MODULOS.GESTAO_ESTRATEGICA, MODULOS.REMUNERACAO_VARIAVEL],
        },
      ],
    };
  }

  handleLabel(tipo) {
    const { intl, resources } = this.props;
    let label = intl.formatMessage({ id: tipo.label });

    if (tipo.resource) {
      label = intl.formatMessage(
        { id: tipo.label },
        { [tipo.resource]: capitalizeFirstLetter(resources[tipo.resource]) }
      );
    } else if (tipo.resources && tipo.resources.length > 0) {
      let params = {};
      tipo.resources.map((r) => {
        params = {
          ...params,
          [r]: capitalizeFirstLetter(resources[r]),
        };
        return null;
      });
      label = intl.formatMessage({ id: tipo.label }, { ...params });
    }

    return (
      <span>
        <b>{label}</b>
        <span>:</span>
      </span>
    );
  }

  render() {
    let { tipo, model, disabled, modulosComprados, other } = this.props;

    let { tipos } = this.state;

    let possuiModuloGe = modulosComprados.find((m) => m.id === 1 && m.ativo);
    let possuiModuloMO = modulosComprados.find((m) => m.id === 2 && m.ativo);
    let possuiModuloGR = modulosComprados.find((m) => m.id === 5 && m.ativo);
    let possuiModuloRV = modulosComprados.find((m) => m.id === 3 && m.ativo);
    const hasEPModule = modulosComprados.find(
      (m) => m.id === MODULOS.ESCRITORIO_PROJETOS && m.ativo
    );

    let tiposFiltrados = [];

    if (possuiModuloGe && !possuiModuloRV){
      tipos = tipos.filter((t) => t.id !== 'CardMetas');
    }

    tipos.map((t) => {
      if (
        possuiModuloGe &&
        possuiModuloMO &&
        possuiModuloGR &&
        possuiModuloRV &&
        t.modulos.find((f) => f === 1 || f === 2 || f === 5 || f === 3)
      ) {
        tiposFiltrados.push(t);
      } else if (possuiModuloGe && t.modulos.find((f) => f === 1)) {
        tiposFiltrados.push(t);
      } else if (possuiModuloMO && t.modulos.find((f) => f === 2)) {
        tiposFiltrados.push(t);
      } else if (possuiModuloGR && t.modulos.find((f) => f === 5)) {
        tiposFiltrados.push(t);
      } else if (possuiModuloRV && t.modulos.find((f) => f === 3)) {
        tiposFiltrados.push(t);
      } else if (
        hasEPModule &&
        t.modulos.find((f) => f === MODULOS.ESCRITORIO_PROJETOS)
      ) {
        tiposFiltrados.push(t);
      }

      return null;
    });

    return disabled ? (
      this.handleLabel(tipo)
    ) : (
      <Lookup
        required
        clearable={false}
        labelKey="descricao"
        valueKey="id"
        options={tiposFiltrados}
        model={{
          ...model,
          errors: this.props.showError && !model.value,
        }}
        {...other}
      />
    );
  }
}
function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    modulosComprados: state.user.licenca.modulos,
  };
}
export default injectIntl(connect(mapStateToProps)(TipoTela));
